import React, { useEffect } from 'react';
import '../css/Information.css';
import Information from "../components/Information";
import { contactDetails } from "../config/stockEyesConfig";

function RefundsAndCancellationPolicies() {

    useEffect(() => {
        document.title = "Refunds and Cancellation Policies";
    }, []);

    return (
        <Information title={"Refunds and Cancellation Policies"}>
            <p>At StocksEyes, we value transparency and want you to have a clear understanding of how our refund and cancellation processes work. Please review the following policies before purchasing or subscribing to our services.</p>

            <ol>
                <li>Digital Product Nature</li>
            </ol>
            <p>All our services, including stock data APIs and other tools, are digital and provided immediately upon successful purchase. As such, traditional return policies do not apply.</p>

            <ol start="2">
                <li>Refund Policy</li>
            </ol>
            <p>All purchases are final and non-refundable. However, we will consider refund requests under the following specific conditions:</p>
            <ul>
                <li>You were charged more than once for the same service.</li>
                <li>You were unable to access the product due to a technical fault on our end.</li>
                <li>There was a confirmed billing error made by us.</li>
            </ul>
            <p>To be eligible for a refund, requests must be made within <strong>7 days</strong> from the date of purchase.</p>
            <p><strong>Refund Timelines:</strong> Upon approval, refunds will be processed within a minimum of <strong>2 business days</strong> and a maximum of <strong>7 business days</strong>. The refund will be issued via the original payment method.</p>

            <ol start="3">
                <li>Cancellation Policy</li>
            </ol>
            <p>You may cancel your subscription or plan at any time. However, cancellations do not trigger a refund for the remaining period. Your access will remain active until the current billing cycle ends.</p>

            <ol start="4">
                <li>Service Downtime</li>
            </ol>
            <p>We aim for maximum uptime, but temporary interruptions may occur. Refunds are not provided for downtime unless it exceeds <strong>48 consecutive hours</strong> due to a confirmed issue on our side.</p>

            <ol start="5">
                <li>Policy Amendments</li>
            </ol>
            <p>We reserve the right to update these policies at any time. All updates will be reflected on this page. Continued use of our services constitutes agreement with the latest version.</p>

            <ol start="6">
                <li>Contact for Refund or Cancellation</li>
            </ol>
            <p>If you meet the refund criteria or wish to cancel a service, please email us at <a href={`mailto:${contactDetails.email}`} target="_new">{contactDetails.email}</a> or call {contactDetails.phone}. Include your full name, email, and order ID for faster assistance.</p>
        </Information>
    );
}

export default RefundsAndCancellationPolicies;
